import { combineReducers } from "@reduxjs/toolkit"
import JafReducer from "./Jaf/jaf.slice"
import authReducer from "./auth.slice"
import mediaReducer from "./Media/media.slice"
import branchReducer from "./Branches/branch.slice"
import PayBillReducer from "./PayBill"
import PayrollReducer from "./Account/payroll.slice"
import EmployeeReducer from "./Employee"
import LocationReducer from "./Location"
import payGroupReducer from "./PayGroups/payGroup.slice"
import securityReducer from "./Security"
import CustomersReducer from "./Customers/customers.slice"
import schedulesReducer from "./Schedules/schedules.slice"
import AuditTrailReducer from "./AuditTrail/auditTrail.slice"
import LoginTrailReducer from "./LoginTrail/loginTrail.slice"
import StaticDataReducer from "./StaticData"
import GeolocationReducer from "./Geolocation/geolocation.slice"
import RotaPlannerReducer from "./RotaPlanner/rotaPlanner.slice"
import SDBillGroupReducer from "./StaticData/SDBillGroup.slice"
import globalStateReducer from "./globalState.slice"
import workMonitorReducer from "./workMonitor/workMonitor.slice"
import commandCenterReducer from "./CommandCenter/commandCenter.slice"
import FeatureFlagsReducer from "./featureFlags.slice"
import organizationReducer from "./Organization"
import tenantReducer from "./Tenant/tenant.slice"

const rootReducer = combineReducers({
	jaf: JafReducer,
	auth: authReducer,
	media: mediaReducer,
	branch: branchReducer,
	payBill: PayBillReducer,
	payroll: PayrollReducer,
	employee: EmployeeReducer,
	location: LocationReducer,
	security: securityReducer,
	billGroup: SDBillGroupReducer,
	customers: CustomersReducer,
	payGroups: payGroupReducer,
	schedules: schedulesReducer,
	auditTrail: AuditTrailReducer,
	loginTrail: LoginTrailReducer,
	staticData: StaticDataReducer,
	geolocation: GeolocationReducer,
	globalState: globalStateReducer,
	rotaPlanner: RotaPlannerReducer,
	workMonitor: workMonitorReducer,
	commandCenter: commandCenterReducer,
	featureFlags: FeatureFlagsReducer,
	organization: organizationReducer,
	tenant: tenantReducer,
})

export default rootReducer
